<div class="flex-container">
  <div class="flex-item">
    <h3 class="margin-top-0">{{ 'common.labels.searchCriteria' | transloco }}</h3>
    @if (isNameSearch()) {
      <div>
        <div class="flex-container">
          <span class="flex-item">{{ 'common.labels.name2' | transloco }}</span>
          <span class="flex-item-2">{{ order.businessSearchCriteria!.name }}</span>
        </div>
      </div>
    }
    @if (isNumberSearch()) {
      <div>
        <div class="flex-container">
          <span class="flex-item">{{ 'common.labels.number2' | transloco }}</span>
          <span class="flex-item-2">{{ order.businessSearchCriteria!.number }}</span>
        </div>
      </div>
    }
    @if(isAdmin) {
      <div>
        <div class="flex-container">
          <span class="flex-item">{{ 'orderBusinessSearchCriteria.scope' | transloco }}</span>
          <span class="flex-item-2">{{ order.businessSearchCriteria!.businessSearchScopeID }}</span>
        </div>
      </div>
    }
  </div>
  @if (shouldShowSearchParameters()) {
    <div class="flex-item">
      <h3 class="margin-top-0">{{ 'orderBusinessSearchCriteria.searchParameters' | transloco }}</h3>
      <div class="flex-container">
        <span class="flex-item">{{ 'orderBusinessSearchCriteria.searchType' | transloco }}</span>
        <span class="flex-item-2">{{ getSearchType() | enumLabel:'businessSearchCriteriaType' }}</span>
      </div>
        <div class="flex-container">
          <span class="flex-item">{{ 'orderBusinessSearchCriteria.showResultsFrom' | transloco }}</span>
          @if (!isAdmin) {
            <span class="flex-item-2">
              {{ getJurisdictionLabels($safeNavigationMigration(order.searchParameters?.searchJurisdictions)).join(', ') }}
            </span>
          }
          @if (isAdmin) {
            <span class="flex-item-2" role="button" tabindex="0" [attr.aria-label]="'orderBusinessSearchCriteria.editSearchJurisdictions' | transloco"
            (click)="openJurisdictionsDialog()" (keydown.enter)="openJurisdictionsDialog()"
            (keydown.space)="$event.preventDefault(); openJurisdictionsDialog()">
              <a class="flex-item-2 link-style">{{ getJurisdictionLabels($safeNavigationMigration(order.searchParameters?.searchJurisdictions)).join(', ') }}</a>
            </span>
          }
        </div>
    </div>
  }
</div>